import React, { useState } from 'react';

function ImageSession({ alt = '', style, onError, onLoad, ...props }) {
  const [failed, setFailed] = useState(false);
  return (
    <img
      {...props}
      alt={alt}
      style={failed ? { ...style, visibility: 'hidden' } : style}
      onError={(event) => {
        setFailed(true);
        onError?.(event);
      }}
      onLoad={(event) => {
        setFailed(false);
        onLoad?.(event);
      }}
    />
  );
}

// Native plain Image leaves its space empty on failure, without retrying.
// Keep that policy separate from RecoverableImage and reset for each new URL.
export default function PlainImage(props) {
  return props.src?.trim() ? <ImageSession key={props.src} {...props} /> : null;
}
